import { usePreventScroll } from '../../../utils/hooks';
import { Button, Modal } from 'antd';
import { useGlobalState } from './GlobalState';
import React, { useRef } from 'react';
import alarm from '../assets/images/alarm.svg';
import loadingAnimation from '../assets/animations/loading-spinner.json';
import Lottie from 'lottie-react';
import { sendWidgetMessage } from '../../../utils/widgetUtils';

function QueueModal({ open = false, fisheryPublicId }) {
  usePreventScroll('BookingQueue', open);
  const spinnerRef = useRef(null);
  const [fisheryInfo] = useGlobalState('fisheryInfo');
  const [isInsideWidget] = useGlobalState('isInsideWidget');

  return (
    <Modal
      open={open}
      width='min(95%, 40rem)'
      title={null}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
      className='queue-modal'
    >
      <div className='sb-blue-900 gRegular txt-center fs-22 lh-1.3'>
        <img src={alarm} alt='Alarm' className='mg-bottom-15' />
        <h2 className='gSemiBold fs-22'>
          We are currently experiencing a high volume of users trying to book
          this venue.
        </h2>
        <p className='mg-bottom-0'>
          You are being held in a digital queue and will be permitted to book
          once you reach the front of the queue.
        </p>
        <Lottie
          lottieRef={spinnerRef}
          animationData={loadingAnimation}
          autoplay={true}
          loop={true}
          className='mg-auto-lr'
          style={{ width: 100 }}
        />
        <Button
          className='sb-blue-bg-600 gSemiBold brFull fs-22 sb-blue-100 txt-center w-full pd-10 h-fit txt-wrap antd-link-button-override'
          href={!isInsideWidget ? `/fishery/${fisheryPublicId}` : undefined}
          onClick={() => {
            if (isInsideWidget) {
              sendWidgetMessage({ type: 'widgetCollapse' });
            }
          }}
        >
          {isInsideWidget
            ? 'Close Booking Widget'
            : 'Return to Fishery Profile'}
        </Button>
        <Button
          className='sb-blue-bg-100 gSemiBold brFull fs-22 sb-blue-700 txt-center w-full pd-10 mg-top-15 mg-bottom-25 h-fit txt-wrap antd-link-button-override'
          onClick={() => {
            if (!window?.location) {
              return;
            }
            window.location.reload();
          }}
        >
          Refresh Page
        </Button>
        <p className='fs-20'>
          <strong className='gBold'>Note</strong>: This high volume is isolated
          to{' '}
          {fisheryInfo?.venue_name ? (
            <span className='sb-blue'>'{fisheryInfo.venue_name}'</span>
          ) : (
            'this fishery'
          )}
          . All other venues are live and our systems are fully operational.
        </p>
      </div>
    </Modal>
  );
}

export default QueueModal;
